import { type ComponentChildren } from 'preact';
import * as stylex from '@stylexjs/stylex';
import { styles } from './card.styles';
interface CardProps {
  title?: string;
  sub?: string;
  action?: ComponentChildren;
  /** Body padding. 'none' lets tables/lists sit flush; 'md' = the prototype `.card-pad`. */
  padding?: 'none' | 'md';
  children: ComponentChildren;
}
const paddingMap = {
  none: styles.paddingNone,
  md: styles.paddingMd
} as const;
export function Card({
  title,
  sub,
  action,
  padding = 'none',
  children
}: CardProps) {
  const hasHead = title != null || action != null;
  return <div {...stylex.props(styles.card)}>
      {hasHead && <div {...stylex.props(styles.head)}>
          {title != null && <div>
              {/* R-346: a DIV, not a heading — the redesign's cards label themselves
                  with a styled div and reserve headings for the page and the dialog.
                  It also resolves an inversion this repo had: a card `h2` rendered
                  SMALLER than a modal `h3`, because the tag tracked document order
                  while the size tracked importance. With card titles out of the
                  heading tree, the remaining levels are monotonic. */}
              <div {...stylex.props(styles.title)}>{title}</div>
              {sub != null && <div {...stylex.props(styles.sub)}>{sub}</div>}
            </div>}
          {action}
        </div>}
      <div {...stylex.props(paddingMap[padding])}>{children}</div>
    </div>;
}